import { Recipe } from '../../api/Recipe';
import { Author } from '../../api/Author';

export const prependRecipeIfMissing = (recipes: Recipe[], recipe: Recipe): Recipe[] =>
  recipes.some((currentRecipe) => currentRecipe.id === recipe.id)
    ? recipes
    : [recipe, ...recipes];

export const replaceRecipeById = (
  recipes: Recipe[],
  recipeId: Recipe['id'],
  nextRecipe: Recipe
): Recipe[] =>
  recipes.map((recipe) => (recipe.id === recipeId ? nextRecipe : recipe));

export const removeRecipeById = (recipes: Recipe[], recipeId: Recipe['id']): Recipe[] =>
  recipes.filter((recipe) => recipe.id !== recipeId);

export const mergeUpdatedAuthorIntoRecipes = (
  recipes: Recipe[],
  updatedAuthor: Author
): Recipe[] =>
  recipes.map((recipe) => {
    if (recipe.authors?.id !== updatedAuthor.id) {
      return recipe;
    }

    return {
      ...recipe,
      authors: {
        ...recipe.authors,
        ...updatedAuthor,
      },
    };
  });

export const logRealtimeRecipeError = (action: 'INSERT' | 'UPDATE', error: unknown) => {
  const actionLabel = action === 'INSERT' ? 'complete recipe' : 'complete updated recipe';
  console.error(`Error fetching ${actionLabel} for Realtime ${action}:`, error);
};
